import { authenticatedAxios } from '../backend.service'
const version = 'v2'
const paths = {
  me: () => `${version}/usuario/me`,
  verificarTerminosCondiciones: () => `${version}/contrato/terminos-condiciones`,
  aceptarTerminosCondiciones: () => `${version}/contrato/terminos-condiciones`,
}

export const getUserContrato = async () => {
  // console.log('🚀 ~ getUserContrato ~ authenticatedAxios:', authenticatedAxios)

  const response = await authenticatedAxios.get(paths.me())
  const data = response?.data
  // El backend indica el rol admin con el flag `admin === 'S'`.
  // Normalizamos a un booleano `isAdmin` para desacoplar la UI del formato del backend.
  return {
    ...data,
    isAdmin: data?.admin === 'S',
  }
}

export const verificarTerminosCondiciones = async () => {
  const response = await authenticatedAxios.get(paths.verificarTerminosCondiciones())
  return response?.data
}
export const aceptarTerminosCondiciones = async () => {
  await authenticatedAxios.post(paths.aceptarTerminosCondiciones())
}
